import { Permission } from '@app/types/blackroom-api';
import {
  IconDownload,
  IconEye,
  IconLock,
  IconProps,
} from '@tabler/icons-react';

function renderPermissionIcon(permission: Permission, props?: IconProps) {
  switch (permission) {
    case 'Resource_AccessRedacted':
      return <IconLock {...props} />;
    case 'Resource_AccessOriginal':
      return <IconEye {...props} />;
    case 'Resource_Download':
      return <IconDownload {...props} />;
  }
  return null;
}

export default renderPermissionIcon;
